export type NestedKeyof<ObjectType extends object> = {
  [Key in keyof ObjectType & string]: ObjectType[Key] extends object
    ? `${Key}` | `${Key}.${NestedKeyof<ObjectType[Key]> extends infer U extends string ? U : never}`
    : `${Key}`;
}[keyof ObjectType & string];

export const ResolveByNestedKey = <ObjectType extends object>(path: NestedKeyof<ObjectType>, obj: ObjectType): unknown =>
  path
    .split('.')
    .reduce((acc: unknown, key: string) => (typeof acc === 'object' && acc !== null ? (acc as Record<string, unknown>)[key] : null), obj);
